import { useState } from 'react';

import PlusIcon from '@images/accordion-plus.svg?react';
import MinusIcon from '@images/accordion-minus.svg?react';

import { AreaProgramCard } from '../AreaProgramCard';

import {
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
  StyledAccordionTitle,
} from './AreaProgramsAccordion.styles';
import { StyledAreaIcon } from '@components/MajorCard/MajorCard.styles';
import { getMajorIconSrc } from '@utils/major';

export interface AreaProgramsAccordionProps {
  areaTitle?: string;
  areaCipCode: number;
  areaPrograms: number[];
}

export const AreaProgramsAccordion = (props: AreaProgramsAccordionProps) => {
  const { areaTitle, areaCipCode, areaPrograms } = props;
  const [isOpenAccordion, setIsOpenAccordion] = useState(false);

  const areaIconSrc = getMajorIconSrc(areaCipCode);
  const accordionIndicator = isOpenAccordion ? <MinusIcon /> : <PlusIcon />;

  const handleOpenAccordion = (accordionId: number) => () => {
    if (accordionId === areaCipCode) {
      setIsOpenAccordion((prevState) => !prevState);
    }
  };

  return (
    <StyledAccordion key={areaCipCode} onClick={handleOpenAccordion(areaCipCode)}>
      <StyledAccordionSummary expandIcon={accordionIndicator}>
        <StyledAreaIcon imageSrc={areaIconSrc} />

        <StyledAccordionTitle component="h3" variant="h5">
          {areaTitle}
        </StyledAccordionTitle>
      </StyledAccordionSummary>

      <StyledAccordionDetails>
        {areaPrograms.map((cipCode) => (
          <AreaProgramCard key={cipCode} programCipCode={cipCode} />
        ))}
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
